var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eyes",style:(_vm.position)},[_c('Eye',{ref:"left",staticClass:"eye eye--left"}),_c('Eye',{ref:"right",staticClass:"eye eye--right"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }